import React, { useContext } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { AGENCY_REPORTS_READ } from '../Constants/RolesAndPermissions';
import {
  Customer,
  isRoleWatcher,
  checkPermissions,
  User,
  UserContext,
  SubscriptionsResume,
  isPlanConnect
} from 'ui-smartforce-settings';

export interface RouteOnboardingGuardProps extends RouteProps {
  customer?: Customer;
  url: string;
  user: User;
  subscriptionsResume?: SubscriptionsResume;
}

export const RouteOnboardingGuard = ({
  children,
  customer,
  path,
  url,
  subscriptionsResume,
  user
}: RouteOnboardingGuardProps) => {
  const { isOnboarding } = useContext(UserContext);

  return (
    <Route
      path={path}
      children={() => {
        if (
          !user.agency_id ||
          (customer && customer.status === 'Inactive') ||
          isOnboarding ||
          !subscriptionsResume?.hasSubscription
        ) {
          return children;
        } else {
          let redirectPath: string;

          if (isRoleWatcher(user.role.id)) {
            redirectPath = 'analytics';
          } else if (
            !subscriptionsResume.appPlan.cc ||
            isPlanConnect(subscriptionsResume.appPlan.cc)
          ) {
            redirectPath = 'business-card';
          } else {
            const allowAgencyReports = checkPermissions(
              AGENCY_REPORTS_READ,
              user.role.permissions
            );
            redirectPath = allowAgencyReports ? 'agency-reports' : 'report';
          }

          return <Redirect to={{ pathname: `${url}/${redirectPath}` }} />;
        }
      }}
    ></Route>
  );
};
